import type { FaireProductEntity } from "../../entity_types/product";

export const p_unbvdpt9vz: FaireProductEntity = {
  token: "p_unbvdpt9vz",
  type: "product",
  name: "Táche Original Barista Blend Pistachio Milk",
  brandToken: "b_jaxvn3rd8j",
  brandName: "Táche Pistachio Milk",
  imageUrl: "https://cdn.faire.com/fastly/76c7b4c4ed9d2fa8e6418982a00679ac983ea692ca7727a4cf8ae686d5b68648.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c2496dff57f6a94077db8b6833dd9b97a3983779658db6cb167a36325519e74d.png",
    "https://cdn.faire.com/fastly/ed3a2ed01ad7c777178e59c57b9099df5ea2f5e7ce1fc45216d72e5bc13bc87c.png",
    "https://cdn.faire.com/fastly/c59ff098069e80bcc358745e1e591c8ddae101c5bcfa9fec69d9f12e31759435.png",
    "https://cdn.faire.com/fastly/013b6780870eb53088827147f55dc80763a5e6bb510f86fab531659d3fe7f2b7.png",
    "https://cdn.faire.com/fastly/b12e106cb946d1bf8742dc825279c2c1b08706df61155dea1eab373f9778ac6e.png"
  ],
  priceDollars: 4.5,
  description: "A creamy, barista-formulated blend of pure pistachios made without any aded oils or fillers. With exceptional frothing abilities, Táche Original Barista Blend is designed specifically to complement warm beverages. Subtly sweet and impossibly delicious, this is coffee’s favorite milk.\n\n• Better Tasting: A little bit nutty and a little bit sweet with a velvety mouthfeel. Perfect in lattes, hot chocolate, and more.\n\n• Better for the Planet: Pistachio trees require 75% less water than almonds.\n\n• Better for You: Unlike oat milk, Táche has no added rapeseed or canola oil.\n\n• Ready to Enjoy: Táche is shelf stable with a shelf life of up to one year. Our milk ships in cases of 6 x 1L cartons. Pro tip: order in multiples of two cases for most efficient shipping.\n\n• Uniquely Táche: Try Táche in matcha, bubble tea, espresso drinks, and more. Reach out for recipe ideas!",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:11.379Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
